import React, { useEffect, useState } from 'react'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { LoadingWave } from '@CommonComponents'
import { Section } from './Section'
import { ItemGroup } from '../base_comps/ItemGroup'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'

export const DeepLinkSetup = () => {
  const [currentState, dispatch] = useStateValue()
  const [loading, setLoading] = useState(false)

  let pathParts = window.location.pathname.split('/')
  let cnum = pathParts[3]
  let contextId = pathParts[4]

  useEffect(() => {
    async function resetSelectedLinks() {
      await dispatch({
        type: 'sectionSelection',
        selectedSections: [],
      })
    }
    resetSelectedLinks()
  }, [])

  useEffect(() => {
    async function getSectionData(coursenum, contextId, dispatch) {
      setLoading(true)
      try {
        let resp = await client.get(
          endpoints.getDeepLinkInfo({
            coursenum: coursenum,
            contextId: contextId,
          })
        )
        await dispatch({
          type: 'loadDeepLinkData',
          bookSections: resp.data.bookSections,
          allSecIds: resp.data.allSecIds,
          allChapIds: resp.data.allChapIds,
          expandedChaps: resp.data.allChapIds,
          inCanvasSections: resp.data.inCanvas,
          masterCoursenum: resp.data.masterCoursenum,
        })
        setLoading(false)
      } catch (err) {
        setLoading(false)
        console.log(err)
        toast.error(err.response.data.error)
      }
    }
    getSectionData(cnum, contextId, dispatch)
  }, [])

  const checkSecSelection = chapId => {
    let sects = currentState.bookSections.filter(
      chap => chap[0][1] === chapId
    )[0][1]
    let secIds = sects.map(el => el.secId)
    if (currentState.selectedSections.length < 1) {
      return false
    }
    let chapChecked = secIds.every(id =>
      currentState.selectedSections.includes(id)
    )
    return chapChecked
  }

  const handleCheckChange = (
    chapId,
    bookSects,
    selectedSects,
    selected,
    dispatch
  ) => {
    let sects = bookSects.filter(chap => chap[0][1] === chapId)[0][1]
    let secIds = []
    sects.forEach(el => secIds.push(el.secId))
    let selectedIds = selectedSects
    if (selected) {
      // unchecking chapter checkbox
      secIds.forEach(function (secId) {
        selectedIds = selectedIds.filter(item => item !== secId) // removing chapter sections from selected
      })
    } else {
      secIds.forEach(function (secId) {
        // checking chapter checkbox
        if (!selectedIds.includes(secId)) {
          selectedIds.push(secId) // add chapter sections to selected
        }
      })
    }

    dispatch({
      type: 'sectionSelection',
      selectedSections: selectedIds,
    })
  }

  const handleCollapseChange = (
    chapId,
    expandedChaps,
    isExpanded,
    dispatch
  ) => {
    let expChapIds = currentState.expandedChaps
    if (isExpanded) {
      expChapIds = expandedChaps.filter(id => id !== chapId)
    } else {
      expChapIds.push(chapId)
    }
    dispatch({
      type: 'expandChapters',
      payload: expChapIds,
    })
  }

  const displaySections = (secArray, inCanvasSects, chapId, selectedSects) => {
    let inCanvasIDs = inCanvasSects.map(sec => sec[0])
    return secArray.map((sect, i) => {
      let inCanvas = inCanvasIDs.includes(sect.secId)
      return (
        <Section
          title={`${sect.label} ${sect.title}`}
          inCanvas={inCanvas}
          secId={sect.secId}
          chapId={chapId}
          selected={selectedSects.includes(sect.secId)}
          key={`${sect.secId}-${i}`}
        />
      )
    })
  }

  return (
    <React.Fragment>
      {loading ? (
        <div className="d-flex justify-content-center">
          <LoadingWave />
        </div>
      ) : (
        currentState.bookSections.map(chapArray => {
          let chapId = chapArray[0][1]
          let selected = checkSecSelection(chapId)
          let expanded = currentState.expandedChaps.includes(chapId)
          return (
            <ItemGroup
              key={chapId}
              childCompsFunc={displaySections}
              childData={[
                chapArray[1],
                currentState.inCanvasSections,
                chapId,
                currentState.selectedSections,
              ]}
              linksPosting={currentState.linksPosting}
              linksPosted={currentState.linksPosted}
              handleCheckChange={handleCheckChange}
              handleCollapseChange={handleCollapseChange}
              itemId={chapId}
              itemTitle={chapArray[0][0]}
              selected={selected}
              expandedArray={currentState.expandedChaps}
              selectedArray={currentState.selectedSections}
              allGroups={currentState.bookSections}
              dispatch={dispatch}
              expanded={expanded}
            />
          )
        })
      )}
    </React.Fragment>
  )
}
